// extracted by mini-css-extract-plugin
export var root = "Fxb6F6OeeO0NC5xG5LaG";